export const nl = {
  // App branding
  appName: 'Hekaya',

  // Navigation
  home: 'Home',
  forYou: 'Voor jou',
  myList: 'Mijn lijst',
  profile: 'Profiel',
  userProfile: 'Gebruikersprofiel',

  // Authentication
  signIn: 'Inloggen',
  signUp: 'Aanmelden',
  signOut: 'Uitloggen',
  signInWithApple: 'Inloggen met Apple',
  signUpWithApple: 'Aanmelden met Apple',
  signInWithGoogle: 'Inloggen met Google',
  signUpWithGoogle: 'Aanmelden met Google',
  appleSignInFailed: 'Inloggen met Apple mislukt. Probeer het opnieuw.',
  appleAuthExpired: 'Apple-code verlopen',
  appleAuthRetrying: 'Automatisch opnieuw proberen...',
  appleAuthRetryFailed: 'Inloggen met Apple mislukt. Probeer het opnieuw.',
  appleAuthMaxRetriesReached: 'Te veel pogingen. Probeer het later opnieuw.',
  appleSignInCancelled: 'Inloggen met Apple is geannuleerd.',
  appleAccountAlreadyExists: 'Er bestaat al een account met deze Apple ID. Log in.',
  appleAccountNotFound: 'Geen account gevonden met deze Apple ID. Meld je eerst aan.',
  googleSignInFailed: 'Inloggen met Google mislukt. Probeer het opnieuw.',
  googleAuthRetrying: 'Automatisch opnieuw proberen...',
  googleAuthMaxRetriesReached: 'Te veel pogingen. Probeer het later opnieuw.',
  or: 'of',
  email: 'E-mail',
  emailOrPhone: 'E-mail of telefoon',
  enterEmail: 'Voer je e-mailadres in',
  enterEmailOrPhone: 'Voer je e-mailadres of telefoonnummer in',
  emailOrPhonePlaceholder: 'email@voorbeeld.nl of +31612345678',
  signInRequired: 'Inloggen vereist',
  toWatchThisEpisode: 'Om deze aflevering te bekijken',
  toAddEpisodeToFavorites: 'Om deze aflevering aan je favorieten toe te voegen',
  pleaseSignInToWatch: 'Log in om deze aflevering te bekijken',
  pleaseSignInToAddFavorite: 'Log in om deze aflevering aan je favorieten toe te voegen',
  pleaseSignInToAddSerieFavorite: 'Log in om deze serie aan je favorieten toe te voegen',
  pleaseSignInToSubscribe: 'Log in om je te abonneren',
  pleaseSignInToAccessRewards: 'Log in om alle functies te gebruiken en je beloningen bij te houden.',
  subscriptionRequired: 'Abonnement vereist',
  episodeRequiresPremium: 'Deze aflevering vereist een premium-abonnement',

  // Force update
  updateRequired: 'Update vereist',
  currentVersion: 'Huidige versie',
  requiredVersion: 'Vereiste versie',
  updateNow: 'Nu bijwerken',
  appCannotBeUsedWithoutUpdate: 'De app kan niet worden gebruikt zonder update',
  forceUpdateDefaultMessage: 'Er is een nieuwe versie van de app beschikbaar. Werk bij om de app te blijven gebruiken.',

  // Recommended update
  updateAvailable: 'Update beschikbaar',
  recommendedVersion: 'Aanbevolen versie',
  updateButton: 'Bijwerken',
  laterButton: 'Later',
  updateWillBeShownAgainIn24Hours: 'Deze update wordt over 24 uur opnieuw getoond',
  recommendedUpdateMessage: 'Er is een nieuwe versie van de app beschikbaar met verbeteringen en nieuwe functies. We raden aan om bij te werken voor de beste ervaring.',

  // Errors
  error: 'Fout',
  pleaseFillAllFields: 'Vul alle velden in',
  failedToCreateAccount: 'Account aanmaken mislukt',
  invalidCredentials: 'Ongeldige inloggegevens',
  accountDisabled: 'Dit account is uitgeschakeld',
  emailAlreadyExists: 'Dit e-mailadres is al in gebruik door een ander account',
  phoneAlreadyExists: 'Dit telefoonnummer is al in gebruik door een ander account',
  invalidEmailFormat: 'Voer een geldig e-mailadres in',
  invalidPhoneFormat: 'Voer een geldig telefoonnummer in',
  accountMergeNotSupported: 'Er bestaat al een account met dit e-mailadres. Log in met je oorspronkelijke inlogmethode.',

  // Content
  searchDramas: 'Drama\'s zoeken...',
  noResultsFound: 'Geen resultaten gevonden voor "{query}"',
  searchResultsOne: '1 resultaat voor "{query}"',
  searchResultsMany: '{count} resultaten voor "{query}"',
  allSeries: 'Alle series',
  topCharts: 'Toplijsten',
  recommendedForYou: 'Aanbevolen voor jou',
  basedOnPreferences: 'Op basis van je voorkeuren',
  continueWatching: 'Verder kijken',
  resumeWatching: 'Verder kijken',
  similarToWatched: 'Vergelijkbaar met wat je hebt bekeken',
  trendingSearches: 'Populaire zoekopdrachten',
  noSeriesInProgress: 'Geen series in voortgang',
  startWatchingToSee: 'Begin met het kijken van een serie om deze hier te zien',
  noContentAvailable: 'Geen inhoud beschikbaar',
  checkSupabaseConfig: 'Controleer je Supabase-configuratie',

  // Series and episodes
  seasons: 'Seizoenen',
  season: 'Seizoen',
  episodes: 'Afleveringen',
  synopsis: 'Samenvatting',
  episode: 'Aflevering',
  play: 'Afspelen',
  swipeToSeeMore: 'Veeg om meer te zien',
  myListAction: 'Mijn lijst',
  addToMyList: 'Toevoegen aan favorieten',
  removeFromMyList: 'Verwijderen uit favorieten',
  popular: 'Populair',
  new: 'Nieuw',
  trending: 'Trending',
  highlight: 'Uitgelicht',
  free: 'Gratis',
  premium: 'Premium',
  premiumEpisode: 'Premium-aflevering',
  signInToUnlock: 'Log in om te ontgrendelen',
  subscribeToWatch: 'Abonneer om te kijken',

  // Profile
  subscribeToPremium: 'Upgrade naar Premium',
  subscribeWithDCB: 'Upgrade naar Premium met DCB',
  dcbSubscribeModalTitle: 'Mobiel betalen abonnement',
  dcbSubscribeLoading: 'Betaling voorbereiden...',
  dcbSubscribeError: 'Kan de betaalpagina niet laden.',
  dcbSubscribeRetry: 'Opnieuw proberen',
  restorePurchases: 'Aankopen herstellen',
  purchaseProcessing: 'Verwerken...',
  subscriptionActivated: 'Abonnement succesvol geactiveerd!',
  webPaymentUnavailable: 'Webbetalingen zijn momenteel niet beschikbaar. Probeer het later opnieuw.',
  paymentInitializing: 'Betaalsysteem is nog aan het initialiseren. Probeer het over een paar seconden opnieuw.',
  loadingOffers: 'Aanbiedingen laden...',
  purchasesRestored: 'Je abonnement is succesvol hersteld! Je hebt nu toegang tot alle premium-inhoud.',
  noPurchasesToRestore: 'Geen actieve abonnementen gevonden om te herstellen. Als je denkt dat dit een fout is, neem dan contact op met de klantenservice.',
  purchaseFailed: 'Aankoop mislukt. Probeer het opnieuw.',
  restoreFailed: 'Aankopen herstellen mislukt.',
  restoreNetworkError: 'Verbindingsprobleem. Controleer je internetverbinding en probeer het opnieuw.',
  restoreReceiptInUse: 'Dit store-account is al gekoppeld aan een ander profiel. Meld je aan met het oorspronkelijke account om dit abonnement te gebruiken.',
  noActiveSubscription: 'Geen actief abonnement gevonden om te herstellen.',
  iapNotAvailable: 'In-app aankopen zijn niet beschikbaar.',
  webPurchaseNotSupported: 'In-app aankopen zijn niet beschikbaar op het web. Gebruik de mobiele app.',

  // Premium subscription paywall
  premiumSubscriptionTitle: 'Premium maandabonnement',
  premiumSubscriptionTagline: 'Ontgrendel onbeperkte toegang tot alle dramaseries en afleveringen',
  whatYouGet: 'Wat je krijgt',

  // Profile subscription information
  profileSubscriptionDescription: 'Krijg onbeperkte toegang tot alle dramaseries en afleveringen met ons maandabonnement.',
  profileBenefit1: 'Bekijk elke aflevering uit onze volledige bibliotheek',
  profileBenefit2: 'Directe toegang tot alle nieuwe afleveringen',
  profileBenefit3: 'Kijkervaring zonder advertenties',

  premiumBenefit1: 'Onbeperkte toegang tot alle dramaseries - bekijk elke aflevering, op elk moment',
  premiumBenefit2: 'Volledige bibliotheek met honderden afleveringen',
  premiumBenefit3: 'Directe toegang tot alle nieuwe afleveringen bij release',
  premiumBenefit4: 'Bekijk elke aflevering zonder beperkingen of limieten',
  premiumBenefit5: 'Kijkervaring zonder advertenties voor ononderbroken entertainment',
  premiumBenefit6: 'Hoogwaardige videostreaming voor de beste kijkervaring',
  premiumBenefit7: 'Toegang op al je apparaten - telefoon, tablet en web',
  bestValue: 'Beste waarde',
  subscriptionIncludes: 'Volledige toegang tot alle inhoud',
  perMonth: '/maand',
  perWeek: '/week',
  startSubscription: 'Abonnement starten',
  learnMoreAboutSubscription: 'Meer informatie over het abonnement',

  // Subscription terms
  subscriptionTerms: 'Je wordt gefactureerd via je account tegen de prijs die op het abonnementsscherm wordt weergegeven. Het abonnement wordt maandelijks automatisch verlengd, tenzij je het ten minste 24 uur voor de verlengingsdatum annuleert. Kosten worden 24 uur voor het einde van je huidige factureringsperiode in rekening gebracht.',

  // Subscription details modal
  subscriptionDetails: 'Abonnementsdetails',
  whatIsIncluded: 'Wat is inbegrepen',
  subscriptionDetailsDescription: 'Je Premium maandabonnement geeft je onbeperkte toegang tot alle dramaseries en afleveringen in onze bibliotheek. Dit omvat alle huidige inhoud en alle nieuwe afleveringen die tijdens je abonnementsperiode worden uitgebracht. Je kunt elke aflevering bekijken, op elk moment, op elk van je apparaten zonder beperkingen.',
  howBillingWorks: 'Hoe facturering werkt',
  billingDescription: 'Je wordt gefactureerd via je account tegen de prijs die op het abonnementsscherm wordt weergegeven. Het abonnement wordt elke maand automatisch verlengd, tenzij je het ten minste 24 uur voor de verlengingsdatum annuleert. Kosten worden 24 uur voor het einde van je huidige factureringsperiode in rekening gebracht.',
  howToCancel: 'Hoe te annuleren',
  cancellationDescription: 'Je kunt je abonnement op elk moment annuleren via je apparaatinstellingen. Voor iOS: Instellingen > [Je naam] > Abonnementen. Voor Android: Google Play Store > Menu > Abonnementen. Selecteer deze app en tik op Abonnement annuleren. Je abonnement blijft actief tot het einde van de huidige factureringsperiode.',
  cancellationDescriptionIos: 'Je kunt je abonnement op elk moment annuleren via je apparaatinstellingen. Voor iOS: Instellingen > [Je naam] > Abonnementen. Selecteer deze app en tik op Abonnement annuleren. Je abonnement blijft actief tot het einde van de huidige factureringsperiode.',
  cancellationDescriptionAndroid: 'Je kunt je abonnement op elk moment annuleren via je apparaatinstellingen. Voor Android: Google Play Store > Menu > Abonnementen. Selecteer deze app en tik op Abonnement annuleren. Je abonnement blijft actief tot het einde van de huidige factureringsperiode.',
  subscriptionExpiry: 'Wat gebeurt er als het abonnement verloopt',
  expiryDescription: 'Als je annuleert of je abonnement verloopt, verlies je de toegang tot premium-inhoud. Je kijkgeschiedenis en favorieten worden echter bewaard. Je kunt je op elk moment opnieuw abonneren om volledige toegang tot alle premium-afleveringen te herkrijgen.',
  deviceCompatibility: 'Apparaatcompatibiliteit',
  compatibilityDescription: 'Je abonnement werkt op alle platforms waar je hetzelfde account gebruikt. Log in met hetzelfde account op elk apparaat om toegang te krijgen tot je premium-voordelen.',
  helpFeedback: 'Help & feedback',
  language: 'Taal',
  notifications: 'Meldingen',
  notificationSettings: 'Meldingsinstellingen',
  pushNotifications: 'Pushmeldingen',
  enabled: 'Ingeschakeld',
  disabled: 'Uitgeschakeld',
  enable: 'Inschakelen',
  enabling: 'Inschakelen...',
  pushNotificationsEnabled: 'Pushmeldingen succesvol ingeschakeld',
  pushNotificationsDisabled: 'Pushmeldingen uitgeschakeld',
  enablePushNotificationsInSettings: 'Om meldingen te ontvangen, schakel ze in via je apparaatinstellingen.',
  openSettings: 'Instellingen openen',
  pushNotificationsEnabledDescription: 'Je ontvangt meldingen op dit apparaat',
  pushNotificationsDisabledDescription: 'Schakel meldingen in om op de hoogte te blijven',
  notificationCategories: 'Meldingscategorieen',
  notificationCategoriesDescription: 'Kies welke soorten meldingen je wilt ontvangen',
  newEpisodes: 'Nieuwe afleveringen',
  newEpisodesDescription: 'Word op de hoogte gebracht wanneer nieuwe afleveringen worden uitgebracht',
  recommendations: 'Aanbevelingen',
  recommendationsDescription: 'Gepersonaliseerde inhoudssuggesties voor jou',
  subscriptionReminders: 'Abonnementsherinneringen',
  subscriptionRemindersDescription: 'Herinneringen over je abonnementsstatus',
  rewardsNotifications: 'Beloningen & prestaties',
  rewardsNotificationsDescription: 'Updates over je beloningen en voortgang',
  marketingNotifications: 'Marketing & aanbiedingen',
  marketingNotificationsDescription: 'Speciale aanbiedingen en promotionele inhoud',
  failedToUpdatePreferences: 'Meldingsvoorkeuren bijwerken mislukt',
  failedToRequestPermission: 'Meldingstoestemming aanvragen mislukt',
  signInToSavePreferences: 'Log in om je meldingsvoorkeuren op te slaan op al je apparaten',
  done: 'Klaar',
  contactUs: 'Neem contact op',
  settings: 'Instellingen',
  privacyPolicy: 'Privacybeleid',
  privacySettings: 'Privacy & toestemming',
  cookieSettings: 'Mijn cookie-instellingen',
  localStorage: 'Lokale opslag',
  termsConditions: 'Algemene voorwaarden',
  legalNotice: 'Juridische kennisgeving',
  pricingConditions: 'Prijsvoorwaarden',
  unsubscribe: 'Uitschrijven',
  unsubscribeInfo: 'Uitschrijfinformatie',
  loadingUnsubscribeInfo: 'Uitschrijfinformatie laden...',
  unsubscribeContentNotAvailable: 'Uitschrijfinformatie is momenteel niet beschikbaar.',
  dcbUnsubscribeButton: 'Mijn abonnement opzeggen',
  dcbUnsubscribeConfirmTitle: 'Bevestiging',
  dcbUnsubscribeConfirmMessage: 'Weet je zeker dat je je abonnement wilt opzeggen? Je verliest de toegang tot premium-inhoud.',
  dcbUnsubscribeSuccess: 'Je abonnement is succesvol opgezegd. Je bent niet meer geabonneerd op de dienst.',
  dcbUnsubscribeError: 'Kan je abonnement niet opzeggen. Neem contact op met de klantenservice.',
  loadingPrivacyPolicy: 'Privacybeleid laden...',
  privacyPolicyNotAvailable: 'Het privacybeleid is momenteel niet beschikbaar.',
  loadingTermsConditions: 'Algemene voorwaarden laden...',
  termsConditionsNotAvailable: 'De algemene voorwaarden zijn momenteel niet beschikbaar.',
  cookies: 'Cookies',
  cookiesSection: 'Cookies',
  legalSection: 'Juridische informatie',
  loadingCookies: 'Cookie-informatie laden...',
  cookiesNotAvailable: 'Cookie-informatie is momenteel niet beschikbaar.',
  loadingLegalNotice: 'Juridische kennisgeving laden...',
  legalNoticeNotAvailable: 'Juridische kennisgeving is momenteel niet beschikbaar.',
  loadingPricingConditions: 'Prijsvoorwaarden laden...',
  pricingConditionsNotAvailable: 'Prijsvoorwaarden zijn momenteel niet beschikbaar.',
  retry: 'Opnieuw proberen',
  noEmailApp: 'Geen e-mailtoepassing beschikbaar op dit apparaat.',
  errorOpeningEmail: 'Kan e-mailtoepassing niet openen.',
  errorOpeningSettings: 'Kan systeeminstellingen niet openen.',
  security: 'Beveiliging',

  // Loading and errors
  loading: 'Laden...',
  loadingContent: 'Inhoud laden...',
  preparingVideo: 'Video voorbereiden...',

  seasonNotFound: 'Seizoen niet gevonden',
  episodeNotFound: 'Aflevering niet gevonden',
  rubriqueNotFound: 'Rubriek niet gevonden',

  // Video player
  loadingVideo: 'Video laden...',
  loadingPlayer: 'Speler laden...',
  loadingEpisodes: 'Afleveringen laden...',

  // Badges and labels
  min: 'min',
  enemiesToLovers: 'Van vijanden tot geliefden',

  // Actions
  cancel: 'Annuleren',
  delete: 'Verwijderen',
  remove: 'Verwijderen',
  removeFromList: 'Verwijderen uit mijn lijst',
  subscribe: 'Abonneren',
  selectLanguage: 'Taal selecteren',
  restartRequired: 'Herstart vereist',
  restartMessage: 'Herstart de app om de nieuwe lay-outrichting toe te passen.',
  restartToApplyLanguage: 'De app herstarten om de nieuwe taal toe te passen?',
  ok: 'OK',
  save: 'Opslaan',
  saving: 'Opslaan...',
  editProfile: 'Profiel bewerken',
  pseudo: 'Bijnaam',
  enterPseudo: 'Voer je bijnaam in',
  pseudoPlaceholder: 'Kies een unieke naam (max 16 tekens)',
  pseudoTaken: 'Deze bijnaam is al in gebruik',
  pseudoInvalid: 'Deze bijnaam bevat ongepaste inhoud',
  pseudoInvalidCharacters: 'Deze bijnaam bevat ongeldige tekens',
  pseudoNotAccepted: 'Kies een andere bijnaam, deze kan niet worden geaccepteerd',
  pseudoMaxLength: 'Bijnaam mag maximaal 16 tekens bevatten',
  pseudoCharactersCount: '{{count}}/16 tekens',
  editPseudo: 'Bijnaam bewerken',
  pseudoUpdated: 'Bijnaam succesvol bijgewerkt',
  subtitles: 'Ondertiteling',
  off: 'Uit',
  noSubtitlesAvailable: 'Geen ondertiteling beschikbaar',
  playbackSpeed: 'Afspeelsnelheid',
  normalSpeed: 'Normaal',
  profileInformation: 'Profielinformatie',
  dateOfBirth: 'Geboortedatum',
  phoneNumber: 'Telefoonnummer',
  enterPhoneNumber: 'Voer je telefoonnummer in',
  notProvided: 'Niet opgegeven',
  dateFormatHint: 'Formaat: {format} (bijv. {example})',
  dateFormatPattern: 'DD-MM-JJJJ',
  dateFormatExample: '31-12-1990',
  invalidDateFormat: 'Gebruik het formaat: {format}',
  invalidDate: 'Ongeldige datum',

  // Placeholders and descriptions
  discoverGenre: 'Ontdekken',

  // Time and duration
  m: 'M',
  now: 'nu',
  minuteAbbrev: 'm',
  hourAbbrev: 'u',
  dayAbbrev: 'd',
  monthAbbrev: 'mnd',

  // History and viewing progress
  noViewingHistory: 'Geen kijkgeschiedenis',
  episodesWillAppearHere: 'Afleveringen die je bekijkt verschijnen hier',
  history: 'Geschiedenis',
  series: 'Series',
  noFavoritesYet: 'Nog geen favorieten',
  addContentToFavorites: 'Voeg series en afleveringen toe aan je favorieten om ze hier te zien',

  // My Purchases
  myPurchases: 'Mijn aankopen',
  purchased: 'Gekocht',
  myPurchasesTitle: 'Je ontgrendelde afleveringen',
  myPurchasesDescription: 'Vind hier alle premium-afleveringen die je met je munten hebt ontgrendeld. Blijf kijken om meer munten te verdienen!',
  tutorialStep1Title: 'Bekijk afleveringen',
  tutorialStep1Description: 'Verdien munten door gratis inhoud op het platform te bekijken.',
  tutorialStep2Title: 'Verzamel beloningen',
  tutorialStep2Description: 'Voltooi uitdagingen en log dagelijks in om nog meer munten te verdienen.',
  tutorialStep3Title: 'Ontgrendel premium-inhoud',
  tutorialStep3Description: 'Gebruik je munten om exclusieve premium-afleveringen te ontgrendelen.',
  goToRewards: 'Naar beloningen',

  // Gamification notifications
  userSignupNotification: 'Welkom! Je hebt {coins} munten verdiend voor het aanmaken van je account!',
  dailyVisitNotification: 'Je hebt {coins} munten verdiend voor je dagelijks bezoek!',
  emailProvidedNotification: 'Je hebt {coins} munten verdiend voor het opgeven van je e-mailadres!',
  msisdnProvidedNotification: 'Je hebt {coins} munten verdiend voor het opgeven van je telefoonnummer!',
  birthDateProvidedNotification: 'Je hebt {coins} munten verdiend voor het opgeven van je geboortedatum!',
  completeProfileNotification: 'Je hebt {coins} munten verdiend voor het voltooien van je profiel!',
  pseudoProvidedNotification: 'Je hebt {coins} munten verdiend voor het aanmaken van een bijnaam!',
  selectImageSource: 'Selecteer afbeeldingsbron',
  takePhoto: 'Foto nemen',
  chooseFromLibrary: 'Kiezen uit bibliotheek',
  removeProfilePicture: 'Profielfoto verwijderen',
  removeProfilePictureConfirm: 'Weet je zeker dat je je profielfoto wilt verwijderen?',
  profilePictureUpdated: 'Profielfoto succesvol bijgewerkt',
  profilePictureRemoved: 'Profielfoto succesvol verwijderd',
  failedToPickImage: 'Afbeelding selecteren uit bibliotheek mislukt',
  failedToTakePhoto: 'Foto nemen mislukt',
  failedToUploadImage: 'Afbeelding uploaden mislukt. Probeer het opnieuw.',
  imageInappropriateContent: 'Afbeelding bevat ongepaste inhoud',
  failedToUpdateProfilePicture: 'Profielfoto bijwerken mislukt',
  failedToRemoveProfilePicture: 'Profielfoto verwijderen mislukt',
  watchEpisodeNotification: 'Je hebt {coins} munten verdiend voor het bekijken van een aflevering!',
  watchAdsNotification: 'Je hebt {coins} munten verdiend voor het bekijken van advertenties!',
  enableNotificationsNotification: 'Je hebt {coins} munten verdiend voor het inschakelen van meldingen!',
  followSocialNotification: 'Je hebt {coins} munten verdiend voor het volgen van ons op sociale media!',
  coinsEarnedNotification: 'Je hebt {coins} munten verdiend!',
  coinsUsedForPremiumNotification: 'Je hebt {coins} munten gebruikt om deze premium-aflevering te ontgrendelen!',
  firstCoinsUsageNotification: 'Welkom! Je hebt zojuist je eerste premium-aflevering ontgrendeld met munten!',

  // Reward Center
  rewardCenter: 'Beloningencentrum',
  rewards: 'Beloningen',
  weeklyRanking: 'Wekelijkse ranglijst',
  hallOfFame: 'Hall of Fame',
  thisWeeksTopPlayers: 'Topspelers van deze week',
  allTimeChampions: 'Allertijden-kampioenen',
  totalCoinsAllTime: 'totale munten',
  coinsThisWeek: 'munten deze week',
  achievements: 'prestaties',
  dayStreakRecord: 'dagen-reeks',
  you: 'Jij',
  noRankingData: 'Geen ranglijstgegevens beschikbaar',
  checkBackLaterRanking: 'Kom later terug voor wekelijkse ranglijsten',
  noHallOfFameData: 'Geen Hall of Fame-gegevens beschikbaar',
  checkBackLaterHallOfFame: 'Kom later terug voor allertijden-ranglijsten',
  coins: 'Munten',
  days: 'dagen',
  dailyCheckIn: 'Dagelijkse check-in',
  earnRewards: 'Verdien beloningen',
  completed: 'Voltooid',
  claim: 'Te doen',
  comingSoon: 'Binnenkort',
  day: 'Dag',
  today: 'Morgen',
  totalCoins: 'Totale munten',
  getCoins: 'Verdien munten,',
  keepWatching: 'Blijf kijken',
  dayStreak: 'Dagen-reeks',
  nextReward: 'Volgende beloning',
  availableTomorrow: 'Beschikbaar morgen',
  weekProgress: 'Weekvoortgang',
  serie: 'Reeks',
  won: 'Gewonnen',
  tomorrow: 'Morgen',
  toDo: 'Te doen',
  firstWeek: 'Eerste week',
  secondWeek: 'Tweede week',
  amazingStreak: 'Geweldige reeks! Ga zo door!',
  overallProgress: 'Algemene voortgang',
  of: 'van',
  eventsCompleted: 'evenementen voltooid',
  ofMissionsCompleted: 'van de missies voltooid',

  // Gamification event categories
  gamificationCategoryUser: 'Gebruiker',
  gamificationCategoryProfile: 'Profiel',
  gamificationCategoryContent: 'Inhoud',
  gamificationCategoryGeneral: 'Algemeen',
  gamificationCategoryDailyMission: 'Dagelijkse missie',
  gamificationCategoryWelcomeMissions: 'Welkomstmissies',
  gamificationCategoryWatchMissions: 'Kijkmissies',
  gamificationCategoryOnceAYear: 'Eenmaal per jaar',

  // Gamification Intro Modal (for guests)
  gamificationIntroSubtitle: 'Voltooi missies en verdien munten!',
  gamificationFeature1Title: 'Maak je account aan',
  gamificationFeature1Desc: 'Ontvang {{coins}} welkomstmunten bij je aanmelding',
  gamificationFeature2Title: 'Bekijk afleveringen',
  gamificationFeature2Desc: 'Verdien {{coins}} munten voor elke aflevering die je voltooit',
  gamificationFeature3Title: 'Klim in de ranglijst',
  gamificationFeature3Desc: 'Vergelijk jezelf elke week met andere leden',
  gamificationFeature4Title: 'Ontgrendel premium-afleveringen',
  gamificationFeature4Desc: 'Gebruik je munten om nog meer afleveringen te bekijken',
  gamificationBonusText: '+{{coins}} gratis munten bij aanmelding!',
  createAccount: 'Account aanmaken',
  connectToYou: 'Inloggen',

  // All Episodes Control
  allEpisodes: 'Alle afleveringen',
  watchNow: 'Nu bekijken',
  previousEpisode: 'Vorige',
  nextEpisode: 'Volgende',

  // App availability
  appNotAvailable: 'Deze applicatie is nog niet beschikbaar in jouw land en taal.',
  appNotAvailableSubtext: 'We werken eraan om onze dienst uit te breiden naar meer regio\'s.',

  // Biometric authentication
  biometricLogin: 'Biometrische login',
  signInWithBiometric: 'Inloggen met biometrie',
  signInWithWebAuthn: 'Inloggen met WebAuthn',
  signInWithFaceId: 'Inloggen met Face ID',
  signInWithTouchId: 'Inloggen met Touch ID',
  enableBiometric: 'Biometrische login inschakelen',
  disableBiometric: 'Biometrische login uitschakelen',
  biometricNotAvailable: 'Biometrische authenticatie is niet beschikbaar op dit apparaat',
  biometricAuthFailed: 'Biometrische authenticatie mislukt',
  biometricDataMissing: 'Biometrische inloggegevens ontbreken. Log in met OTP en schakel biometrische login opnieuw in via je profielinstellingen.',
  biometricNoUserData: 'Log eerst in en schakel vervolgens biometrische login in via je profielinstellingen.',
  biometricUnexpectedError: 'Er is een onverwachte fout opgetreden. Log in met OTP en schakel biometrische login opnieuw in via je profielinstellingen.',
  biometricAuthCancelled: 'Biometrische authenticatie is geannuleerd. Probeer het opnieuw.',
  webauthnNotEnabled: 'Log eerst in en schakel vervolgens WebAuthn-login in via je profielinstellingen.',
  webauthnCancelled: 'WebAuthn-authenticatie is geannuleerd. Probeer het opnieuw.',
  webauthnFailed: 'WebAuthn-authenticatie mislukt',
  biometricLoginEnabled: 'Biometrische login is ingeschakeld',
  biometricLoginDisabled: 'Biometrische login is uitgeschakeld',
  webauthnLoginEnabled: 'WebAuthn-login is ingeschakeld',
  webauthnLoginDisabled: 'WebAuthn-login is uitgeschakeld',
  faceIdLoginEnabled: 'Face ID-login is ingeschakeld',
  faceIdLoginDisabled: 'Face ID-login is uitgeschakeld',
  touchIdLoginEnabled: 'Touch ID-login is ingeschakeld',
  touchIdLoginDisabled: 'Touch ID-login is uitgeschakeld',
  androidBiometricLoginEnabled: 'Biometrische login is ingeschakeld',
  androidBiometricLoginDisabled: 'Biometrische login is uitgeschakeld',
  failedToEnableBiometric: 'Biometrische login inschakelen mislukt',
  failedToDisableBiometric: 'Biometrische login uitschakelen mislukt',
  failedToEnableWebauthn: 'WebAuthn-login inschakelen mislukt',
  failedToDisableWebauthn: 'WebAuthn-login uitschakelen mislukt',
  success: 'Gelukt',
  enableBiometricPrompt: 'Biometrische authenticatie inschakelen voor snel inloggen?',
  enableBiometricPromptIos: '{authType} inschakelen voor snel inloggen?',
  'Enable {{authType}}?': '{{authType}} inschakelen?',
  'Would you like to enable {{authType}} for faster login?': 'Wil je {{authType}} inschakelen voor sneller inloggen?',
  '{{authType}} login has been enabled!': '{{authType}}-login is ingeschakeld!',
  'Failed to enable {{authType}} login. Please try again later.': '{{authType}}-login inschakelen mislukt. Probeer het later opnieuw.',
  biometricLoginTitle: 'Biometrische login',
  faceIdLogin: 'Face ID-login',
  touchIdLogin: 'Touch ID-login',
  useBiometricToSignIn: 'Gebruik vingerafdruk of gezichtsherkenning om snel in te loggen',
  enableBiometricForSignIn: 'Schakel vingerafdruk of gezichtsherkenning in voor snel inloggen',
  useFaceIdToSignIn: 'Gebruik Face ID om snel in te loggen',
  enableFaceIdForSignIn: 'Schakel Face ID in voor snel inloggen',
  useTouchIdToSignIn: 'Gebruik Touch ID om snel in te loggen',
  enableTouchIdForSignIn: 'Schakel Touch ID in voor snel inloggen',

  // Delete account
  deleteMyAccount: 'Mijn account verwijderen',
  deleteAccountConfirmation: 'Bevestiging van verwijdering',
  deleteAccountWarningNotSubscribed: 'We zullen je account verwijderen. Je hebt na bevestiging geen toegang meer tot Hekaya.\n\nLet op: in overeenstemming met de regelgeving bewaren we bepaalde gegevens veilig, bijvoorbeeld voor mogelijke geschillenbeslechting.',
  deleteAccountWarningSubscribed: 'Je hebt momenteel een actief abonnement. Zeg dit eerst op. Je vindt de opzeginstructies in "Mijn account", "Uitschrijven". Zodra het abonnement is opgezegd, kun je je account verwijderen.\n\nWe zullen je account verwijderen. Je hebt na bevestiging geen toegang meer tot Hekaya.\n\nLet op: in overeenstemming met de regelgeving bewaren we bepaalde gegevens veilig, bijvoorbeeld voor mogelijke geschillenbeslechting.',
  iConfirm: 'Ik bevestig',
  deletingAccount: 'Account verwijderen...',
  accountDeleted: 'Account verwijderd',
  accountDeletedSuccess: 'Je account is succesvol verwijderd',
  accountDeleteError: 'Fout bij het verwijderen van account',
  activeSubscriptionErrorTitle: 'Actief abonnement',
  activeSubscriptionErrorMessage: 'Je moet je abonnement opzeggen voordat je je account kunt verwijderen.',
  gracePeriodErrorTitle: 'Verwijdering nog niet mogelijk',
  gracePeriodErrorMessage: 'Je abonnement is opgezegd, maar blijft actief tot de vervaldatum. Je kunt je account verwijderen zodra deze periode is afgelopen.',
  gracePeriodBannerTitle: 'Abonnement opgezegd',
  gracePeriodBannerMessage: 'Je abonnement is opgezegd maar blijft actief tot {{date}}. Je behoudt toegang tot alle premium-inhoud tot die tijd.',
  notBilledDenyBannerTitle: 'Abonnement opgeschort',
  notBilledDenyBannerMessage: 'Je abonnement is tijdelijk opgeschort vanwege een betalingsprobleem. Om de toegang tot onze dienst te herstellen, vul je account aan *9. Je Hekaya-account wordt opnieuw geactiveerd zodra de betaling is verwerkt.',

  // Network connection
  noInternetConnection: 'Geen internetverbinding beschikbaar. Controleer je verbinding en probeer het opnieuw.',
  noInternetConnectionShort: 'Geen internetverbinding',
  checkInternetConnection: 'Controleer je internetverbinding',
  connectionRequired: 'Internetverbinding vereist',
  dismiss: 'Offline doorgaan',
  slowNetworkDetected: 'Traag netwerk gedetecteerd',
  poorNetworkConnection: 'Je netwerkverbinding ondervindt problemen. Het laden van video duurt langer dan normaal.',
  loadingTime: 'Laadtijd',
  slowConnection: 'Trage verbinding',

  // App version
  version: 'Versie',

  // Image cache
  imageCacheStorage: 'Afbeeldingscache-opslag',
  cachedImages: 'Gecachte afbeeldingen',
  storageUsed: 'Gebruikte opslag',
  expiredImages: 'Verlopen afbeeldingen',
  clearExpiredCache: 'Verlopen wissen',
  clearAllCache: 'Alles wissen',
  clearing: 'Wissen...',
  clearImageCache: 'Afbeeldingscache wissen',
  clearImageCacheConfirmation: 'Weet je zeker dat je alle gecachte afbeeldingen wilt wissen? Dit maakt opslagruimte vrij, maar afbeeldingen moeten opnieuw worden gedownload.',
  clearCache: 'Cache wissen',
  cacheCleared: 'Cache succesvol gewist! {{count}} afbeeldingen verwijderd.',
  expiredCacheCleared: 'Verlopen cache gewist! {{count}} verlopen afbeeldingen verwijderd.',
  noExpiredCache: 'Geen verlopen afbeeldingen om te wissen.',
  failedToClearCache: 'Cache wissen mislukt. Probeer het opnieuw.',
  cacheAutoClears30Days: 'Afbeeldingen worden automatisch na 30 dagen gewist',
  info: 'Info',

  // Pagination
  scrollForMore: 'Scroll voor meer',
  noMoreContent: 'Einde van de lijst',
  loadingMore: 'Laden...',

  // OTP Authentication
  otp: {
    signInOrSignUp: 'Log in of maak een gratis account aan',
    subscriptionWelcomeTitle: 'Bedankt voor je abonnement!',
    subscriptionWelcomeMessage: 'Laatste stap: meld je aan om een account te maken of log in op een bestaand account om drama\'s te bekijken.',
    emailPlaceholder: 'E-mailadres',
    phonePlaceholder: 'Telefoonnummer',
    emailOrPhonePlaceholder: 'E-mail of telefoonnummer',
    continue: 'Doorgaan',
    continueWithGoogle: 'Doorgaan met Google',
    continueWithApple: 'Doorgaan met Apple',
    termsPrefix: 'Door verder te gaan, accepteer je onze',
    termsOfService: 'Servicevoorwaarden',
    privacyPolicy: 'Privacybeleid',
    confirmEmail: 'E-mailadres bevestigen',
    confirmYourEmail: 'Bevestig je e-mailadres',
    confirmPhone: 'Telefoonnummer bevestigen',
    confirmYourPhone: 'Bevestig je telefoonnummer',
    codeSentTo: 'We hebben een code gestuurd naar',
    codeSentToPhone: 'We hebben een code gestuurd naar',
    enterCodeBelow: 'Voer deze hieronder in om je account te verifi\u00EBren.',
    resendCode: 'Code opnieuw verzenden',
    resendIn: 'Opnieuw verzenden over',
    verify: 'Verifi\u00EBren',
    connectingInProgress: 'Verbinden...',
    accountCreated: 'Account aangemaakt',
    stayUpdatedTitle: 'Wil je op de hoogte blijven van het laatste nieuws?',
    stayUpdatedDescription: 'We sturen je graag gepersonaliseerde aanbiedingen, inspirerende inhoud, apparaattips en informatie over onze nieuwste innovaties.',
    learnMore: 'Meer informatie',
    subscribe: 'Abonneren',
    noThanks: 'Nee, bedankt',
    enterEmailOrPhone: 'Voer je e-mailadres of telefoonnummer in',
    sendFailed: 'Code verzenden mislukt. Probeer het opnieuw.',
    enterCompleteCode: 'Voer de volledige 6-cijferige code in',
    verificationFailed: 'Verificatie mislukt. Probeer het opnieuw.',
    invalidCode: 'Ongeldige code. Probeer het opnieuw.',
    codeExpired: 'Code is verlopen. Vraag een nieuwe aan.',
    checkSpamFolder: 'Vergeet niet je spammap te controleren',
    dcbValidatingSubscription: 'Je abonnement valideren...',
    dcbActivating: 'Je abonnement activeren...',
    dcbSuccessTitle: 'Abonnement geactiveerd!',
    dcbSuccessMessage: 'Je abonnement is succesvol geactiveerd. Je kunt nu van alle inhoud genieten.',
    dcbStartWatching: 'Begin met kijken',
    dcbErrorTitle: 'Activeringsfout',
    dcbErrorRetry: 'Er is een fout opgetreden bij het activeren van je abonnement. Probeer het opnieuw.',
    dcbPaymentNotFound: 'Abonnement niet gevonden. Controleer je link of neem contact op met de klantenservice.',
    dcbRetryButton: 'Opnieuw proberen',
    dcbIdentityMismatchPhone: 'Het telefoonnummer dat voor het abonnement is gebruikt, is {{identifier}}. Gebruik dit nummer om je account aan te maken.',
    dcbIdentityMismatchEmail: 'Het e-mailadres dat voor het abonnement is gebruikt, is {{identifier}}. Gebruik dit e-mailadres om je account aan te maken.',
    dcbRecoveryBanner: 'Er is een wachtend abonnement gedetecteerd. Maak je account aan om er toegang toe te krijgen.',
    dcbAlreadySubscribed: 'Al geabonneerd via mobiel betalen?',
    dcbEnterPhone: 'Voer het telefoonnummer in dat bij de betaling is gebruikt:',
    dcbRecoverButton: 'Herstellen',
    dcbMsisdnNotFound: 'Geen wachtend abonnement gevonden voor dit nummer.',
    dcbMsisdnRecoveryFailed: 'Herstel mislukt. Probeer het opnieuw.',
    invalidPhoneNumber: 'Ongeldig telefoonnummer.',
  },
  and: 'en',
  smartBannerSubtitle: 'Betere ervaring in de app',
  smartBannerOpen: 'OPENEN',
  paymentVerifying: 'Je abonnement verifi\u00EBren...',
  paymentSuccessTitle: 'Abonnement geactiveerd!',
  paymentSuccessMessage: 'Gefeliciteerd, je hebt nu toegang tot alle Premium-inhoud.',
  paymentSuccessButton: 'Begin met kijken',
  paymentPendingMessage: 'Je betaling is ontvangen. Je abonnement wordt binnenkort geactiveerd.',
  paymentRefreshButton: 'Vernieuwen',
  redirectingToPayment: 'Doorverwijzen naar betaalpagina...',
  webPaymentIframeErrorTitle: 'Betaalpagina niet beschikbaar',
  webPaymentIframeErrorMessage: 'De betaalpagina kon niet in de app worden geladen. Je kunt deze openen in een nieuw tabblad.',
  webPaymentOpenExternal: 'Openen in een nieuw tabblad',

  // Premium subscription card
  enterPremiumExperience: 'Ga naar de',
  mobileInvoice: 'Mobiele factuur',
  mobileInvoicePrice: '\u20AC9,99/maand',
  mobileInvoiceDescription: 'Betaling op je telefoonrekening. Eenvoudig en snel.',
  cardAppleGooglePay: 'Kaart / Apple Pay / Google Pay',
  cardPaymentDescription: 'Veilige betaling per kaart, Apple Pay of Google Pay.',
  dcbPaymentOfferDescription: 'Betaling op je telefoonrekening. Eenvoudig en snel.',
  appStorePaymentTitle: 'App Store',
  appStorePaymentDescription: 'Abonnement gefactureerd en beheerd via je Apple App Store-account.',
  playStorePaymentTitle: 'Google Play',
  playStorePaymentDescription: 'Abonnement gefactureerd en beheerd via je Google Play Store-account.',
  upgradeToPremium: 'Upgrade naar Premium',
  cancelAnytimeNoCommitment: 'Op elk moment opzeggen \u00B7 Zonder verbintenis',
  whyBecomeVip: 'Waarom VIP worden?',
  joinPremiumCommunity: 'Word lid van onze Premium Hekaya-community',
  unlimitedAccessShort: 'Krijg toegang tot alle series en afleveringen zonder limieten.\nKijk wanneer je wilt, waar je wilt.',

  // DCB subscription details (profile view)
  dcbOfferDaily: 'Dagelijks abonnement',
  dcbOfferWeekly: 'Wekelijks abonnement',
  dcbOfferMonthly: 'Maandelijks abonnement',
  dcbOfferQuarterly: 'Kwartaalabonnement',
  dcbOfferYearly: 'Jaarabonnement',
  dcbOfferRecurring: 'Doorlopend abonnement',
  dcbSubscriptionValidity: 'Geldig tot {{date}}',
};
